import MessagingShared from "../../components/MessagingShared";
export default function PsicologoMensajeria() {
    return <MessagingShared allowedRoles={["padre", "profesor"]} />;
}
